<template>
  <ul class="picture-list--vertical">
    <li class="picture-list__header picture-list__header-gs">
      <img src="../images/smi.png" width="35px" height="28px">
    </li>
    <template v-if="!reqPending">
      <li
        v-for="(item, key) in dataCollection"
        :key="key"
        class="picture-list__item picture-list__item--gs"
        @click="showModal($event, item)"
        :style="`background-image: linear-gradient(0deg, ${social.colors[key]}, ${social.colors[key]})`"
      >
        <span class="picture-list__item-title">{{sliceAuthor(item.author)}}</span>

        <p class="picture-list__item-description" v-html="sliceText(item.text)">
        </p>

        <div class="picture-list__item-footer">
          <span class="date-time">{{toDate(item.created_date)}}</span>
        </div>
      </li>
    </template>
    <table-preloader v-else></table-preloader>
  </ul>
</template>

<script>
// mixins
import pictureMixin from '../mixins';

// components
import TablePreloader from '@/components/preLoaders/tablePreloader.vue';

export default {
  name: 'Gs',
  data() {
    return {
      social: {
        name: 'vk',
        id: 4,
        colors: [
          '#7c17e1',
          '#892ee4',
          '#9645e7',
          '#a35dea',
          '#b074ed',
        ],
      },
      dataCollection: [],
      postCount: 5,
    };
  },
  methods: {
    showModal(event, post){
      const target = event.target;
      this.$root.$emit('togglePostToModal', {target, post});
    }
  },
  components: {
    TablePreloader,
  },
  mixins: [
    pictureMixin,
  ],
};
</script>

<style scoped>
  @import "../css/style.css";

  .picture-list--vertical {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .picture-list--vertical .picture-list__header-gs,
  .picture-list--vertical .picture-list__item {
    flex-basis: 33.3%;
  }

  .picture-list__header-gs {
    min-height: 100px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    background-color: #7c17e1;
    box-sizing: border-box;
    border-right: 1px solid #ffffff;
  }

  .picture-list__item--gs {
    border-bottom: 1px solid #ffffff;
    border-right: 1px solid #ffffff;
  }

  @media (max-width: 1365px) {
    .picture-list--vertical {
      width: 365px;
    }

    .picture-list__header-gs {
      display: flex;
      align-items: center;
      flex-basis: 100%;
      min-height: 68px;
      background-color: #7c17e1;
      box-sizing: border-box;
    }

    .picture-list--vertical .picture-list__header-gs,
    .picture-list--vertical .picture-list__item {
      flex-basis: 100%;
    }
  }

  @media (max-width: 1040px) {
    .picture-list--vertical {
      width: 100%;
    }

    .picture-list__header-gs {
      width: 100%;
      height: 160px;
    }

    .picture-list--vertical .picture-list__header-gs,
    .picture-list--vertical .picture-list__item {
      flex-basis: 33.3%;
    }
  }

  @media (max-width: 1040px) {
    .picture-list--vertical {
      width: 100%;
    }

    .picture-list__header-gs {
      height: 160px;
    }

    .picture-list--vertical .picture-list__header-gs,
    .picture-list--vertical .picture-list__item {
      width: 253px;
    }

    /*.picture-list--vertical .picture-list__header-gs,
    .picture-list--vertical .picture-list__item {
      flex-basis: 350px;
    }*/
  }

  @media (max-width: 760px) {
    .picture-list--vertical .picture-list__header-gs,
    .picture-list--vertical .picture-list__item {
      width: 100%;
      flex-basis: 100%;
    }
  }
</style>
